import { getKerioOutOfOffice, setKerioOutOfOffice, } from "@apps/client-sdk";
import { el } from "../dom.js";
import { isKerioAuthError, renderKerioPasswordUpdate, } from "./kerioPasswordUpdate.js";
export function renderKerioOutOfOfficePanel(options) {
    const panel = el("div", "kerio-ooo-panel");
    panel.append(el("p", "hint", "Out of Office uses Kerio Connect auto-reply settings (not a Sieve vacation script)."));
    const enabledLabel = el("label", "checkbox-row");
    const enabledInput = el("input");
    enabledInput.type = "checkbox";
    enabledLabel.append(enabledInput, document.createTextNode(" Enable auto-reply"));
    panel.append(enabledLabel);
    const msgLabel = el("label", "mt", "Message");
    const msgArea = el("textarea", "input sieve-source-editor");
    msgArea.rows = 8;
    panel.append(msgLabel, msgArea);
    const saveBtn = el("button", "btn btn-primary mt", "Save");
    saveBtn.type = "button";
    panel.append(saveBtn);
    let settings = { isEnabled: false, message: "" };
    const paint = () => {
        enabledInput.checked = Boolean(settings.isEnabled);
        msgArea.value = String(settings.message ?? "");
    };
    saveBtn.addEventListener("click", () => {
        void (async () => {
            options.showStatus("Saving out of office…", "muted");
            try {
                const next = {
                    ...settings,
                    isEnabled: enabledInput.checked,
                    message: msgArea.value,
                };
                settings = await setKerioOutOfOffice(options.storage, next);
                paint();
                options.showStatus("Out of office saved.", "success");
            }
            catch (error) {
                options.showStatus(error instanceof Error ? error.message : "Save failed", "error");
            }
        })();
    });
    void (async () => {
        options.showStatus("Loading out of office…", "muted");
        try {
            settings = await getKerioOutOfOffice(options.storage);
            paint();
            options.showStatus("", "muted");
            panel.querySelector(".kerio-password-update")?.remove();
        }
        catch (error) {
            const message = error instanceof Error ? error.message : "Failed to load out of office";
            options.showStatus(message, "error");
            if (isKerioAuthError(message) && !panel.querySelector(".kerio-password-update")) {
                panel.append(renderKerioPasswordUpdate(options.storage, () => {
                    void (async () => {
                        options.showStatus("Loading out of office…", "muted");
                        try {
                            settings = await getKerioOutOfOffice(options.storage);
                            paint();
                            options.showStatus("", "muted");
                            panel.querySelector(".kerio-password-update")?.remove();
                        }
                        catch (retryError) {
                            options.showStatus(retryError instanceof Error
                                ? retryError.message
                                : "Failed to load out of office", "error");
                        }
                    })();
                }));
            }
        }
    })();
    return panel;
}
